import React from 'react';

import {
    HASH_SEED,
    INIT_COLOR,
    INIT_INDEX,
    NUM_COLORS,
    ONE_ELEMENT,
    NOTIFICATIONS_DAYS_SHOW,
    DEFAULT_VALUE,
    ZERO
} from 'util/constants';
import BadRequestFormError from 'util/api/errors/BadRequestFormError';
import ApiError from 'util/api/errors/ApiError';
import {createQueryParams} from 'util/router';
const PERCENT = 100;

//export const getNow = () => Date.now();
export const getNow = () => Date.now();

export const getDocument = () => document;

export const getNavigator = () => navigator;

export const random = (min, max) => ~~(Math.random() * (max - min) + min);

export const convertArrayToMap = (array = [], keyField = 'id', initObject = {}, valueField) => array.reduce((map, obj) => ({
    ...map,
    [obj[keyField]]: valueField ? obj[valueField] : obj
}), initObject);

const SMALLEST_WIDTH = 0;
const MOBILE_RESOLUTION = 768;

const _convertDateToBackEndFormat = timestamp => {
    const date = new Date(timestamp);
    const TACTICAL_SOLUTION_CONSTANT = 1;
    const _addZero = number => typeof number === 'string' ? number.length === TACTICAL_SOLUTION_CONSTANT ? `0${number}` : number : _addZero(`${number}`);


    return `${date.getFullYear()}-${_addZero(date.getMonth() + TACTICAL_SOLUTION_CONSTANT)}-${_addZero(date.getDate())}`;
};

export const convertPeriodToBackEndFormat = period => ({
    startdate: _convertDateToBackEndFormat(period.startDate),
    enddate:   _convertDateToBackEndFormat(period.endDate)
});

export const splitSeconds = seconds => {
    /* eslint-disable no-magic-numbers */
    const basis = [
        ['year', 29030400],
        ['month', 2419200],
        ['week', 604800],
        ['day', 86400],
        ['hour', 3600],
        ['minute', 60],
        ['second', 1]
    ];
    /* eslint-enable no-magic-numbers */

    let prev = seconds;

    return basis.reduce((ret, [unit, mult]) => {
        const value = Math.floor(prev / mult);

        ret.push([value, unit]);

        prev = Math.floor(prev % mult);

        return ret;
    }, []);
};

const NO_DATE = 0;

export const bestFitSeconds = seconds => splitSeconds(seconds).find(([value]) => value > NO_DATE);

export const bestFitMoreSeconds = (seconds, all) => {
    const NEXT_UNIT = 1;
    const splitted = splitSeconds(seconds);
    const index = splitted.findIndex(([value]) => value > NO_DATE);

    return splitted.slice(index, all ? splitted.length : index + NEXT_UNIT);
};

export const preventDefault = e => e.preventDefault();
export const stopPropagation = e => e.stopPropagation();
export const prevDefStopProp = e => {
    preventDefault(e);
    stopPropagation(e);
};

/**
 * Parse the template replacing the parameters. The pattern is ##param## replacing this to row[param].
 * @param {String} template The template to be parsed.
 * @param {Object} values The row with the data to show
 * @param {Function} parser A function to parse the parameters.
 * @param {Boolean} envolve True when the parameters must be envolved by span.
 * @return {String} The new text after conversion.
 */
export const templatize = (template, values, parser, envolve) => {
    const
        reg = /##+(\w)+##/,
        _getParameterTemplate = field => {
            if (parser) {
                const value = parser(values, field);

                if (value !== undefined) {

                    return value;
                }
            }

            return values[field];
        },
        _replaceParameters = text => {
            let
                auxText = text,
                params = reg.exec(auxText),
                ret = [auxText];

            while (params && params.length) {
                const
                    param = params[INIT_INDEX],
                    field = param.replace(new RegExp('##', 'g'), '');

                if (envolve) {
                    ret = ret.reduce((_ret, item) => {
                        if (typeof item === 'string') {
                            const arr = item.split(param);

                            arr.forEach((_item, index) => {
                                _item && _ret.push(~_item.indexOf('##') ?
                                    _item :
                                    <span key={`${field}-b-${index}`} className={`template-field`}>{_item}</span>
                                );

                                index < arr.length - ONE_ELEMENT && _ret.push(<span key={`${field}-${index}`} className={`template-field-${field}`}>{_getParameterTemplate(field)}</span>);
                            });
                        } else {
                            //                            _item && _ret.push(<span key={`${field}-b-${index}`} className={`template-field`}>{_item}</span>);
                            _ret.push(item);
                        }

                        return _ret;
                    }, []);
                }
                auxText = auxText.replace(param, _getParameterTemplate(field));
                params = reg.exec(auxText);
            }

            return envolve ? ret : auxText;
        };

    return _replaceParameters(template);
};
export const selectOnFocus = e => e.currentTarget.select();

export const normalizeText = (() => {
    const
        from = 'ÃÀÁÄÂÈÉËÊÌÍÏÎÒÓÖÔÙÚÜÛãàáäâèéëêìíïîòóöôùúüûÑñÇç',
        to = 'AAAAAEEEEIIIIOOOOUUUUaaaaaeeeeiiiioooouuuunncc',
        mapping = {};

    for (let i = INIT_INDEX, j = from.length; i < j; i++) { mapping[from.charAt(i)] = to.charAt(i) }

    return str => {
        const ret = [];

        for (let i = INIT_INDEX, j = str.length; i < j; i++) {
            const c = str.charAt(i);

            if (mapping[str.charAt(i)]) { ret.push(mapping[c]) } else { ret.push(c) }
        }

        return ret.join('');
    };

})();
export const matchText = (part, whole) => !!~normalizeText(whole.toUpperCase()).indexOf(normalizeText(part.toUpperCase()));
export const matchTextStart = (part, whole) => !normalizeText(whole.toUpperCase()).indexOf(normalizeText(part.toUpperCase()));
export const getSortParam = sortBy => sortBy.field ? `${sortBy.desc ? '-' : ''}${sortBy.field}` : undefined;
export const isDifferent = (a, b) => {
    if (a instanceof Array) {
        if (b instanceof Array) {
            if (a.length === b.length) {
                return a.reduce((ret, item, index) => ret || isDifferent(item, b[index]), false);
            }

            return true;

        }
    } else if (typeof a === 'object' && a !== null) {
        if (typeof b === 'object' && b !== null) {
            return Object.keys(a).reduce((ret, key) => ret || isDifferent(a[key], b[key]) || isDifferent(b[key], a[key]), false);
        }
    } else if (a !== b) {
        return true;
    }

    return false;
};
export const splitHighlight = (text, highlight, minIndex = INIT_INDEX) => {
    const
        nText = normalizeText(text).toUpperCase(),
        nHighlight = normalizeText(highlight).toUpperCase(),
        index = nText.indexOf(nHighlight);

    if (~index) {
        const left = text.substr(INIT_INDEX, index);
        const content = text.substr(index, highlight.length);
        const right = text.substr(index + highlight.length);


        return [left, <b key={minIndex + index}>{content}</b>]
            .concat(splitHighlight(right, highlight, minIndex + index + content.length));
    }

    return [text];
};


/**
 * Says if the filters have changed
 */
export const isFilterChanged = (newFilters, oldFilters) => {
    if (typeof newFilters !== typeof oldFilters) {
        return true;
    }

    const
        newArr = Object.keys(newFilters),
        oldArr = Object.keys(oldFilters);

    if (newArr.length === oldArr.length) {
        return Object.keys(newFilters).reduce((ret, key) => ret || newFilters[key] !== oldFilters[key], false);
    }

    return true;

};

export const isMobile = () => {
    /* eslint-disable no-restricted-globals */
    const width = window.innerWidth > SMALLEST_WIDTH ? window.innerWidth : screen.width;
    /* eslint-enable no-restricted-globals */

    return width <= MOBILE_RESOLUTION;
};

export const debounce = (func, wait, immediate) => {
    let timeout;

    /*eslint-disable*/
    return function() {
        const callNow = immediate && !timeout;
        clearTimeout(timeout);
        //const init = Date.now();
        //console.log('Init', init);
        const context = this, args = arguments;
        const later = function() {
            //console.log('End', Date.now() - init);
            timeout = null;
            if (!immediate) { func.apply(context, args) }
        };
        timeout = setTimeout(later, wait);
        if (callNow) {
            //console.log('Now', Date.now() - init);
            func.apply(context, args)
        }
    }.bind(this);
    /*eslint-enable*/
};

export const getMatchRoute = (routes, path, checkSidebar) => {
    const _matchRoute = (route, _path) => {
        const replacedRoute = route.path.replace(/:[a-zA-Z0-9]*/g, '[a-zA-Z0-9-_]*');
        const routeRegex = new RegExp(`^${replacedRoute}$`, 'g');

        return routeRegex.test(_path);
    };
    const _findMatchRoute = _path => routes.find(route => _matchRoute(route, _path));

    const match = _findMatchRoute(path);

    if (match) {
        if (match.redirect) {
            return _findMatchRoute(match.redirect);
        }
        if (checkSidebar && match.sidebarPath) {
            return _findMatchRoute(match.sidebarPath);
        }
    }

    return match;
};

/**
 * Get the color index since a text
 * @param {string} text The name text for getting the hash
 * @returns {number} The color index
 */
export const getColorIndex = text => {
    let hash = INIT_INDEX;

    for (let i = INIT_INDEX; i < text.length; i++) {
        const char = text.charCodeAt(i);

        /* eslint-disable no-bitwise */
        hash = ((hash << HASH_SEED) - hash) + char;
        hash &= hash;
        /* eslint-enable no-bitwise */
    }

    return Math.abs(hash % NUM_COLORS) + INIT_COLOR;
};

export const getUrlParameters = (url, parameters) => {
    if (url === undefined) {
        throw new Error('url does not exist');
    }

    const params = parameters && Object.keys(parameters).reduce((ret, key) => ({
        ...ret,
        [key]: parameters[key] instanceof Array ?
            parameters[key].length ? parameters[key].join(',') : undefined :
            parameters[key] === '' || parameters[key] === null ? undefined : parameters[key]
    }), {});


    const queryParams = decodeURI(createQueryParams(params));

    return url + (queryParams.length && queryParams !== '?' ? queryParams : '');
};

export const getDeepProperty = (obj, property) => {
    const arr = property.split('.');
    let ret = obj;

    while (ret && arr.length) {
        ret = ret[arr.shift()];
    }

    return ret;
};

export const getErrorMessage = error => new Promise((resolve, reject) => {
    if (typeof error === 'string') {
        resolve(error);
    } else if (error instanceof Error) {
        if (error instanceof BadRequestFormError) {
            getErrorMessage(error.responseBackend)
                .then(resolve)
                .catch(reject);
        } else if (error instanceof ApiError) {
            let msg = error.responseBackend.detail;

            if (msg instanceof Array) {
                msg = msg.shift();
            }

            msg = `error.${msg}`;

            resolve(msg);
        } else {
            resolve(error.message);
        }
    } else if (error instanceof Array) {
        const retErrorArray = error.map(() => false);

        error.forEach((item, index) => {
            getErrorMessage(item)
                .then(msg => {
                    retErrorArray[index] = msg;

                    if (retErrorArray.reduce((ret, _item) => ret || _item, false) !== false) {
                        resolve(retErrorArray);
                    }
                })
                .catch(reject);
        });
    } else if (typeof error === 'object') {
        const arrObject = Object.keys(error);
        const retErrorObject = arrObject.reduce((ret, key) => ({
            ...ret,
            [key]: false
        }), {});

        arrObject.forEach(key => {
            getErrorMessage(error[key])
                .then(msg => {
                    retErrorObject[key] = msg;

                    if (Object.keys(retErrorObject).reduce((ret, retKey) => ret || retErrorObject[retKey] !== false, false)) {
                        resolve(retErrorObject);
                    }
                })
                .catch(reject);
        });
    }
});

export const deserializeRedux = serializedData => {
    if (serializedData) {
        const data = JSON.parse(serializedData);
        const now = module.exports.getNow();
        const ago3days = new Date(now);

        ago3days.setDate(ago3days.getDate() - NOTIFICATIONS_DAYS_SHOW);
        ago3days.setHours(DEFAULT_VALUE, DEFAULT_VALUE, DEFAULT_VALUE, DEFAULT_VALUE);

        return {
            ...data,
            notifications: {
                alerts:        [],
                notifications: data.notifications && data.notifications.notifications.filter(notification => notification.datetime > ago3days.getTime())
            }
        };
    }

    return serializedData;
};

export const myCustomSlicer = paths => state => {
    const subset = {};

    paths.forEach(path => {
        subset[path] = getDeepProperty(state, path);
    });

    const now = module.exports.getNow();
    const ago3days = new Date(now);

    ago3days.setDate(ago3days.getDate() - NOTIFICATIONS_DAYS_SHOW);
    ago3days.setHours(DEFAULT_VALUE, DEFAULT_VALUE, DEFAULT_VALUE, DEFAULT_VALUE);

    return {
        ...subset,
        notifications: {
            alerts:        [],
            notifications: subset.notifications && subset.notifications.notifications.filter(notification => notification.datetime > ago3days.getTime())
        }
    };
};

const _initIsFetching = store => {
    const _initCache = cache => {
        Object.keys(cache).forEach(key => {
            _initIsFetching(cache[key]);
        });

        return store;
    };

    Object.keys(store).forEach(key => {
        switch (key) {
        case 'isFetching':
        case 'isCreating':
        case 'isUpdating':
        case 'isDeleting':
            store[key] = false;
            break;
        case 'cache':
            _initCache(store[key].entities);
            _initCache(store[key].entity);
            break;
        }
    });

    return store;
};

export const myCustomMerge = (initialState, persistedState) => {
    const finalState = {...initialState};

    Object.keys(persistedState).forEach(key => {
        const keyArr = key.split('.');
        const lastKey = keyArr.pop();

        let obj = finalState;

        keyArr.forEach(subKey => {
            if (!obj[subKey]) {
                obj[subKey] = {};
            }
            obj = obj[subKey];
        });

        obj[lastKey] = _initIsFetching(persistedState[key]);
    });


    return finalState;
};

export const getPercent = (totalNumber, number) => {
    const result = (number / totalNumber) * PERCENT;

    return isNaN(result) ? ZERO : result;
};

/**
 * Calculate the difference percent between 2 numbers
 * @param originalNumber
 * @param newNumber
 * @returns {number} if the return is a positive number, this represents an increase percent,
 * if the return is a negative number, this represents an decrease percent
 */
export const getPercentDifference = (originalNumber, newNumber) => {
    const difference = newNumber - originalNumber;
    let differencePercent = difference / originalNumber * PERCENT;

    differencePercent = Math.round(differencePercent * PERCENT) / PERCENT;

    if (differencePercent === ZERO) {
        return {
            difference: ZERO,
            type:       'equal',
            color:      'black',
            icon:       ' '
        };
    }

    const result = {
        difference: Math.abs(differencePercent),
        type:       differencePercent < ZERO ? 'decrease' : 'increase',
        color:      differencePercent < ZERO ? '#00A85F' : '#F68C1F',
        icon:       differencePercent < ZERO ? 'level-down' : 'level-up'
    };


    if (isNaN(result.difference) || result.difference === Infinity) {
        result.difference = ZERO;
        result.icon = '';
    }


    return result;
};



// WEBPACK FOOTER //
// ./src/util/utils.js